<app-header></app-header>
<div class="container verifying-container my-5">
    <div class="row">
        <div class="col-12">
            <div class="text-center mt-5">
                <h3>Verifying</h3>
                <i *ngIf="loading" class="fa fa-circle-notch fa-spin"></i>
                <div *ngIf="error" class="alert alert-warning">
                    {{ error }}
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
